module.exports = __webpack_public_path__ + "img/beep_promo.5f95583d.png";